import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-picker.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/picker/js/design-tokens-px.css.js';
import pickerItemTokens from '@maersk-global/mds-design-tokens/implementation/core/picker-item/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, tokens, pickerItemTokens, style];
